const elements = {
    search: document.getElementById("search")!,
    serialNumber: document.getElementById("serialNumber") as HTMLInputElement,
    passwordContainer: document.getElementById("passwordContainer")!,
    passwordText: document.getElementById("passwordText") as HTMLSpanElement,
};

async function generatePassword() {
    try {
        const serialNumber = elements.serialNumber.value;
        if (!serialNumber) {
            alert('Wprowadź numer seryjny urządzenia');
            return;
        }

        elements.passwordText.textContent = 'Trwa generowanie...';
        const API_URL = window.location.protocol === 'https:' 
        ? 'https://exo-clinic-password-recovery-api.internal.egzotech.com'
        : 'http://localhost:3000';

        const response = await fetch(`${API_URL}/api/generate-password?deviceSerialNumber=${encodeURIComponent(serialNumber)}`);



        
        if (!response.ok) {
            throw new Error(`API error: ${response.status}`);
        }
        
        const data = await response.json();
        elements.passwordText.textContent = data.password;
    } catch (error) {
        console.error('Error getting password:', error);
        elements.passwordText.textContent = 'Błąd generowania hasła';
    }
}

elements.search.addEventListener("click", () => {
    generatePassword();
});

elements.serialNumber.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
        generatePassword();
    }
});
